import compact from 'lodash/compact';
import uniq from 'lodash/uniq';

export const getActiveSection = (geometry, activeSectionId) => {
  if (!geometry) { return null; }
  const result = geometry.filter(section => section.id === activeSectionId);
  return (result.length > 0) ? result[0] : null;
};

export const getSectionName = (sectionObj, areaNames) => {
  const areas = uniq(sectionObj.rows.map(r => r.block));
  if (areas.length > 1) {
    return '';
  }
  const [level, section] = sectionObj.code.split('-');
  const sectionNames = compact([
    areaNames.levels[level] || '',
    areaNames.sections[section] || ''
  ]);
  return sectionNames.join(' – ');
};



// WEBPACK FOOTER //
// ./frontend/react/utils/sim/geometry_utils.js